import {
  Container,
  SubTitle,
  RedSpan,
  DateSpan,
  JustifySectionAr,
  JustifySection,
  SubTitleAr,
} from "./styles";

const AboutContent = () => {
  return (
    <Container>
      <JustifySection>
        <SubTitle>EQDOM : Le partenaire historique des Marocains</SubTitle>
        {/* <BlackSubTitle>
                    Innovation, esprit d’équipe, professionnalisme :
                </BlackSubTitle>
                <ul>
                    <li>
                        <p>
                            <RedSpan>4 valeurs</RedSpan> que nous mettons au
                            service de nos clients depuis près de 40 ans ;
                        </p>
                    </li>
                    <li>
                        <p>
                            <RedSpan>4 valeurs</RedSpan> qui sont celles du
                            groupe Société Générale dont nous sommes filiale
                            depuis 2002. Vous voulez en savoir plus ? Un peu
                            d’histoire…
                        </p>
                    </li>
                </ul> */}
        Depuis sa création en 1974, <RedSpan>Eqdom</RedSpan> s’impose comme un acteur de référence dans le paysage national du crédit à la consommation. Fortement ancré dans une démarche d’excellence, <RedSpan>Eqdom</RedSpan> capitalise sur une expertise éprouvée de plus de 50 ans pour concevoir des offres personnalisées, pensées pour répondre aux besoins concrets des ménages tout en s’adaptant aux évolutions du marché. Son approche centrée sur le client permet d’améliorer les conditions de vie de milliers de familles, en favorisant une consommation utile, durable et inclusive.
        <br></br>
        Acteur incontournable du financement automobile, <RedSpan>Eqdom</RedSpan> développe des synergies solides avec un écosystème de partenaires stratégiques – concessionnaires, loueurs, transporteurs et opérateurs logistiques – pour proposer des solutions innovantes, pensées tant pour les particuliers que pour les professionnels. 
        <br></br>
        <br></br>
        <RedSpan>EQDOM</RedSpan> étend également son offre en facilitant l’acquisition de biens essentiels du quotidien : électroménager, mobilier, équipement multimédia ou encore achats en ligne.
        <br></br>
        <br></br>
        Grâce à un maillage national de 18 agences, complété par une présence digitale forte et innovante ainsi qu’un réseau d’intermédiaires agréés sur tout le territoire et des partenaires reconnus, <RedSpan>Eqdom</RedSpan> incarne une présence de proximité, accessible partout au Maroc. Cette implantation territoriale témoigne d’une volonté constante d’être aux côtés de chaque client, à chaque étape de son parcours et ses moments de vie.
        <br></br>
        <br></br>
        Plus qu’un organisme de financement, <RedSpan>Eqdom</RedSpan> est aujourd’hui un véritable partenaire de confiance au service du développement personnel et économique au Maroc. »
      </JustifySection>

      {/* <Section>
        <SubTitle>50 Ans à Votre Service</SubTitle>
        <RedSpan>Eqdom</RedSpan>, première société de crédit fondée par l'État,
        a été initialement conçue pour soutenir les fonctionnaires dans
        l'acquisition de biens d'équipement. Forts de résultats prometteurs dès
        le départ, nous avons rapidement élargi notre activité pour inclure les
        particuliers, devenant ainsi le leader incontesté du prêt personnel, que
        nous appelons « dispocrédit ». Ce succès a été couronné par
        l’introduction d'<RedSpan>Eqdom</RedSpan> à la Bourse de Casablanca en
        1978.
      </Section> */}
      {/* <Section>
        <SubTitle>Une entreprise en croissance</SubTitle>
        <span>
          Avec son rachat en 2002 par la Société Générale,
          <RedSpan> Eqdom </RedSpan> a montré son potentiel de développement. En
          appartenant désormais à un groupe international et puissant ,
          <RedSpan> Eqdom </RedSpan> répond à ses exigences du professionnalisme
          des équipes, d’un suivi des risques rigoureux et de transparence dans
          la publication de nos résultats.
        </span>
      </Section> */}

      <JustifySection>
        <SubTitle>Dates clés</SubTitle>
        <ul>
          <li>
            <p>
              <DateSpan>1978</DateSpan>: Introduction d’EQDOM à la Bourse de Casablanca
            </p>
          </li>
          <li>
            <p>
              <DateSpan>1992</DateSpan>: Commercialisation par EQDOM du crédit personnel
            </p>
          </li>
          <li>
            <p>
              <DateSpan>1995</DateSpan>: Privatisation de CREDIT EQDOM par une offre Publique de Vente. L’Etat actionnaire vend sa participation (200.000 actions représentant 18% du capital)
            </p>
          </li>
          <li>
            <p>
              <DateSpan>1997</DateSpan>: 1ère émission de BSF : 350 millions MAD.
            </p>
          </li>
          <li>
            <p>
              <DateSpan>2002</DateSpan>: L’ONA cède au groupe Société Générale 44,42% du capital. La même année, la Société Générale lance une OPA partielle sur 8% du Capital.
            </p>
          </li>
          <li>
            <p>
              <DateSpan>2024</DateSpan>: Le Groupe SAHAM acquiert 57,67% des parts du groupe Société Générale, dans la Société Générale Marocaine des Banques, actionnaire majoritaire d’EQDOM. Cette opération renforce la position d’EQDOM sur le marché et ouvre de nouvelles perspectives de croissance.
            </p>
          </li>
        </ul>
      </JustifySection>
      {/*
      <JustifySectionAr dir="rtl">

        <SubTitleAr>المساند التارخي للمغاربة <RedSpan>إكدوم</RedSpan></SubTitleAr>
        منذ تأسيسها سنة 1974، أصبحت <RedSpan>إكدوم</RedSpan> واحدة من أبرز الشركات في مجال القروض الاستهلاكية على المستوى الوطني. وبفضل خبرة تزيد عن خمسين سنة، طورت الشركة عروض تمويل موجهة خصيصاً لتلبية حاجيات الأسر المغربية، مع التكيّف المستمر مع تطورات السوق. تركيز <RedSpan>إكدوم</RedSpan> على الزبون يسمح بتحسين مستوى عيش آلاف العائلات، من خلال تشجيع استهلاك ذكي، مفيد، ومستدام يلائم مختلف الفئات.
        <br></br>
        تعتبر <RedSpan>إكدوم</RedSpan> فاعلاً أساسياً في مجال تمويل السيارات، حيث تطوّر شراكات قوية مع شبكة من الفاعلين الاستراتيجيين مثل وكلاء البيع، شركات الكراء، شركات النقل والخدمات اللوجستية، من أجل تقديم حلول مبتكرة تلبي احتياجات الأفراد والمهنيين على حد سواء. كما تعمل <RedSpan>إكدوم</RedSpan> على توسيع عروضها من خلال تسهيل اقتناء مجموعة من المنتجات الأساسية اليومية، مثل الأجهزة المنزلية، الأثاث، المعدات التكنولوجية، وحتى المشتريات عبر الإنترنت. 
        <br></br>
        <br></br>
        بفضل شبكة وطنية تضم 18 وكالة، مدعومة بحضور رقمي قوي ومبتكر، بالإضافة إلى شبكة من الوسطاء المعتمدين وشركاء موثوقين منتشرين عبر جميع أنحاء المملكة، تُجسد <RedSpan>إكدوم</RedSpan> مفهوم القرب الحقيقي والمتاح في كل مكان بالمغرب. هذا الانتشار الجغرافي يعكس التزام الشركة الدائم بمرافقة كل زبون في مختلف مراحل مسيرته ومحطّات حياته. فـ<RedSpan>إكدوم</RedSpan> ليست مجرد مؤسسة تمويل، بل أصبحت اليوم شريكاً موثوقاً يُساهم في التنمية الشخصية والاقتصادية للمواطن المغربي.
      </JustifySectionAr>
      <JustifySectionAr dir="rtl">
        <SubTitleAr>تواريخ مهمة في مسار <RedSpan>إكدوم</RedSpan> :</SubTitleAr>
        <ul>
          <li>
            <p>
              <DateSpan>1978</DateSpan>: إدراج <RedSpan>إكدوم</RedSpan> في بورصة الدار البيضاء.
            </p>
          </li>
          <li>
            <p>
              <DateSpan>1992</DateSpan>: إطلاق منتج القرض الشخصي من طرف <RedSpan>إكدوم</RedSpan>.
            </p>
          </li>
          <li>
            <p>
              <DateSpan>1995</DateSpan>: خوصصة <RedSpan>إكدوم</RedSpan> من خلال عرض عمومي للبيع؛ حيث قامت الدولة، بصفتها مساهمة، ببيع حصتها المقدّرة ب 200 ألف سهم، أي ما يعادل 18% من رأس المال.
            </p>
          </li>
          <li>
            <p>
              <DateSpan>1997</DateSpan>: أول إصدار لسندات التمويل (BSF) بقيمة 350 مليون درهم.
            </p>
          </li>
          <li>
            <p>
              <DateSpan>2002</DateSpan>: قامت مجموعة ONA ببيع 44.42% من رأسمال <RedSpan>إكدوم</RedSpan> لفائدة مجموعة الشركة العامة ، وفي نفس السنة أطلقت الشركة العامة عرض شراء جزئي بنسبة 8% من رأس المال.
            </p>
          </li>
          <li>
            <p>
              <DateSpan>2024</DateSpan>: مجموعة سهام تستحوذ على 57.67% من أسهم مجموعة الشركة العامة في “الشركة العامة المغربية للأبناك”، المساهم الرئيسي في <RedSpan>إكدوم</RedSpan>. وقد عززت هذه العملية من موقع <RedSpan>إكدوم</RedSpan> في السوق وفتحت آفاقاً جديدة للنمو والتوسع.
            </p>
          </li>
        </ul>
      </JustifySectionAr>
      */}
    </Container>
  );
};

export default AboutContent;
